/**
 * Block 8.2 / 8.3 (2026-05-26): Single tax + ФОП self payments API.
 */
import { api } from './client';
import type { Page } from './catalogs';


export type PeriodKind = 'MONTHLY' | 'QUARTERLY';


export interface SingleTaxCalculation {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  period_kind: PeriodKind;
  period_year: number;
  period_month: number | null;
  period_quarter: number | null;
  tax_group: number;
  tax_amount: string;
  posted: boolean;
  external_source?: string | null;
}

export interface FopSelfPayment {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  period_year: number;
  period_month: number;
  posted: boolean;
  external_source?: string | null;
}


export const singleTax = {
  list: (params?: {
    organization_id?: string; period_year?: number;
    tax_group?: number; posted?: boolean; limit?: number;
  }) =>
    api.get<Page<SingleTaxCalculation>>(
      '/documents/single-tax-calculations', { params },
    ).then((r) => r.data),
};


export const fopSelfEsv = {
  list: (params?: {
    organization_id?: string; period_year?: number;
    posted?: boolean; limit?: number;
  }) =>
    api.get<Page<FopSelfPayment & { esv_amount: string }>>(
      '/documents/fop-self-esv-payments', { params },
    ).then((r) => r.data),
};


export const fopSelfWz = {
  list: (params?: {
    organization_id?: string; period_year?: number;
    posted?: boolean; limit?: number;
  }) =>
    api.get<Page<FopSelfPayment & { wz_amount: string }>>(
      '/documents/fop-self-wz-payments', { params },
    ).then((r) => r.data),
};
